import {
    GET_COUNTRY_INDUSTRY_REPORTS_LIST_SUCCESS, GET_COUNTRY_INDUSTRY_REPORTS_LIST_FAILURE
} from "./action";
const initialState = {
    getCountryIndustryReportsListSuccess: [],
    getCountryIndustryReportsListFailure: [],
    rows: [],
    total: 0,
    page: 0,
};


const countryIndustryReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_COUNTRY_INDUSTRY_REPORTS_LIST_SUCCESS:
            return {
                ...state,
                rows: action.payload.content,
                total: action.payload.total,
                page: action.payload.page,
            };
        case GET_COUNTRY_INDUSTRY_REPORTS_LIST_FAILURE:
            return (state = {
                ...state,
                getCountryIndustryReportsListFailure: action.payload,
            });
        default:
            return state;
    }
};
export default countryIndustryReportsReducer;
